import { Booking } from 'shared-types/booking';

const LIMIT = 360; // 6h
const DAY_IN_MINUTES = 1440;

export const add24Hours = (minutes: number): number =>
  minutes < LIMIT ? minutes + DAY_IN_MINUTES : minutes;

export const add24HoursToBookings = (bookings: Booking[]): Booking[] => {
  return bookings.map((booking) => {
    const newBooking = { ...booking };

    newBooking.startHour = add24Hours(newBooking.startHour);
    newBooking.endHour = add24Hours(newBooking.endHour);

    return newBooking;
  });
};

export const minutesToDate = (minutes: number): Date => {
  const added24h = minutes > DAY_IN_MINUTES;
  const newMinutes = added24h ? minutes - DAY_IN_MINUTES : minutes;
  const date = new Date();
  const isCurrentDateAfterMidnight = date.getHours() < 6;

  date.setHours(Math.floor(newMinutes / 60));
  date.setMinutes(newMinutes % 60);

  if (added24h && !isCurrentDateAfterMidnight) {
    date.setDate(date.getDate() + 1);
  }

  return date;
};
